import styled from 'styled-components';
import { COLORS } from '../../../constants/colors';

export const Container = styled.div`
  border-radius: 8px;
  border: 2px solid ${COLORS.grayBorder};
  background-color: white;
  flex-direction: column;
  position: fixed;
  height: 120px;
  width: 180px;
  bottom: 50%;
  right: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: translate(50%, 50%);
`;
